import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'E.g., Public/State Controlled Institution of Higher Education',
    name: 'Institution Type',
    partialId: PartialId.Standard.create('institution_type'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
